module.exports = __webpack_public_path__ + "static/media/home-nav-bar.e1efe502.svg";